module.exports = __webpack_public_path__ + "static/media/1993_maleRate_femaleRate.ea5df9a8.png";